export default __webpack_public_path__ + "static/media/pagination.16aa1858.svg";